import React from "react";

export const LazyTestAreaPage = React.lazy(
    () => import(/* webpackChunkName: "TestArea" */ "./TestArea")
);
